export default "__VITE_ASSET__913f4ad3__"